/** Picks on the new-duelist banlist track. One per level, five in total. */
export const BANLIST_LEVEL_REWARD_PICKS = 5

/**
 * Account state for the banlist-card track.
 * `anchorLevel` is null when this account is outside the program.
 */
export type BanlistLevelReward = {
  anchorLevel: number | null
  unlocked: number
  claimed: number
  available: number
  chosen: string[]
}

export const EMPTY_BANLIST_LEVEL_REWARD: BanlistLevelReward = {
  anchorLevel: null,
  unlocked: 0,
  claimed: 0,
  available: 0,
  chosen: [],
}

/**
 * How many picks are open at `liveLevel` for an account that entered at `anchor`.
 * The first pick is open on the anchor level. Four more open on the next levels.
 * A level below the anchor (a season wipe) reports 0; the server keeps the stored count.
 */
export function unlockedBanlistPicks(anchor: number, liveLevel: number): number {
  if (!Number.isInteger(anchor) || anchor < 1 || anchor > 5) return 0
  const level = Math.floor(liveLevel)
  if (!Number.isInteger(level) || level < anchor) return 0
  return Math.min(BANLIST_LEVEL_REWARD_PICKS, level - anchor + 1)
}

/**
 * Account level that opens the next pick. Null when the five picks are already open
 * or the account is outside the program.
 */
export function nextBanlistRewardLevel(
  anchor: number,
  unlocked: number,
): number | null {
  if (!Number.isInteger(anchor) || anchor < 1 || anchor > 5) return null
  const open = Math.floor(unlocked)
  if (!Number.isInteger(open) || open < 0 || open >= BANLIST_LEVEL_REWARD_PICKS) {
    return null
  }
  return anchor + open
}
